import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import WelcomeVideo from './components/WelcomeVideo';
import Features from './components/Features';
import VideoSection from './components/VideoSection';
import InteractivePricing from './components/InteractivePricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import AccessibilityWidget from './components/AccessibilityWidget';
import ScrollToTop from './components/ScrollToTop';
import AIReceptionistNYC from './components/AIReceptionistNYC';
import RetellVsThoughtly from './components/RetellVsThoughtly';
import './App.css';
import './accessibility-styles.css';

// Home Page Component
const HomePage = () => (
  <>
    <Hero />
    <AIReceptionistNYC />
    <WelcomeVideo />
    <Features />
    <InteractivePricing />
    <VideoSection />
    <Testimonials />
    <FAQ />
  </>
);

// Retell vs Thoughtly Page Component
const RetellVsThoughtlyPage = () => (
  <>
    <RetellVsThoughtly />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/retell-vs-thoughtly" element={<RetellVsThoughtlyPage />} />
        </Routes>
        <Footer />
        <AccessibilityWidget />
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;